import { AbstractControl, ValidationErrors } from '@angular/forms';
import { PortalFieldConfig } from '@portal/form/data-access';
import { isAfter, isBefore, isValid, startOfDay } from 'date-fns';

export function dateRangeValidator(control: AbstractControl<Date | string | null>, field: PortalFieldConfig): ValidationErrors | null {
  const { value } = control;
  const { minDate, maxDate } = field.props || {};

  if (!value || (!minDate && !maxDate)) return null;

  const dateValue = startOfDay(new Date(value));

  const dateIsBefore = minDate instanceof Date && isBefore(dateValue, minDate);
  const dateIsAfter = maxDate instanceof Date && isAfter(dateValue, maxDate);

  if (dateIsBefore || dateIsAfter) {
    return { dateRange: true };
  }

  return null;
}

export function dateValidValidator(control: AbstractControl<Date | string | null>, field: PortalFieldConfig): ValidationErrors | null {
  return isValid(control?.value) ? null : { dateValid: true };
}
